module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm1_m_en.cb48fb7bddcca252417eff6e32939fed.png";